import { displayErrorsOnView, displayErrorOnField, clearPopoversOnView } from 'utils/forms';
import { showSuccess } from 'utils/messages';

import Base from 'app/views/base';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'submit #user_edit_password': 'submit',
  },

  beforeRender() {
    clearPopoversOnView(this);
  },

  submit(e) {
    e.preventDefault();

    const self = this;
    this.model.update({
      current_password: this.$('#user_current_password').val(),
      password: this.$('#user_password').val(),
      password_confirmation: this.$('#user_password_confirmation').val(),
    }, {
      success() {
        self.render();
        showSuccess('Password successfully updated');
      },
      error(model, response) {
        clearPopoversOnView(self);
        displayErrorsOnView(self, response, ['current_password', 'password', 'password_confirmation']);
      },
    });
  },

  setFocus(attribute) {
    this.$(`#user_${attribute}`).focus();
  },

  displayError(attribute, message) {
    const formField = this.$(`#user_${attribute}`);
    displayErrorOnField(formField, message);
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/user_edit/edit_password/index.js